import { updated } from './dictionary';

export const dictionary = {
    updated,
};
